import React from 'react';
import './ColorBar.css';

const ColorBar: React.FC = () => {
  return (
    <div className="ColorBar-container">
      <div className="ColorBar-div ColorBar-div-first" />
      <div className="ColorBar-div ColorBar-div-second" />
      <div className="ColorBar-div ColorBar-div-third" />
      <div className="ColorBar-div ColorBar-div-fourth" />
    </div>
  );
};

export default ColorBar;
